import { injectIntl } from 'react-intl';
import Footer from './Footer';

export default injectIntl(Footer);
